const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/34644613451"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 flex items-center justify-center bg-[#25D366] text-white rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 cursor-pointer"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-fill text-3xl"></i>
    </a>
  );
};

export default WhatsAppButton;